import { useEffect, useMemo, useRef } from "react"
import { DEFAULT_PARAMS, FlyingPigsBrandGenerator, SceneName } from "./generator/generator"
import { animate } from "motion"

type Props = {
  scene: SceneName
  opacity: number
}

export function PillarRenderer(props: Props) {
  const container = useRef<HTMLDivElement>(null)

  if (env.client) {
    const generator = useMemo(() => {
      const params = { ...DEFAULT_PARAMS }
      return new FlyingPigsBrandGenerator(params)
    }, [FlyingPigsBrandGenerator])

    useEffect(() => {
      generator.setAutoSize(container.current)
      container.current?.appendChild(generator.gl.canvas)
      generator.play()
      generator.update()
      return () => {
        container.current?.removeChild(generator.gl.canvas)
        generator.dispose()
      }
    }, [generator])

    useEffect(() => {
      generator.transitionScene(props.scene)
    }, [props.scene])

    useEffect(() => {
      const a = animate(
        generator,
        {
          opacity: props.opacity,
        },
        {
          duration: 0.4,
        },
      )

      return () => {
        a.stop()
      }
    }, [props.opacity])
  }

  return <div ref={container} className="absolute inset-0"></div>
}
